var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTabsList',{attrs:{"tabsId":"tabsIntro","ariaLabel":"Coach reports","tabs":_vm.tabs},model:{value:(_vm.activeTabId),callback:function ($$v) {_vm.activeTabId=$$v},expression:"activeTabId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }